import Master from "../../layout/Master";
import Card from "../../layout/Card";
import Sidbar from "../../layout/Sidbar";
import './style.css'
import BCButom from "../../Tools/BCButom";
const Chat = ({textTitle, children}) => {
    return (
        <>
            <Master>
                <Sidbar>
                    <div className="imagePagePosts">
                        <h2 style={{textAlign: "center", paddingTop: "100pt", textShadow: "red 1px 0 10px, 1px 1px 2px pink", color: "#FFF"}}>{textTitle}</h2>
                    </div>  

                    <Card>

                    <div className="mainFilter">
                            <div className="titleSection"><h5>فیلتر</h5></div>         

                            <label className="lableFilter">نوع نمایش : </label>
                            <select className="selectFilter"> 
                                <option value={``}>پیشفرض</option>
                                <option value={``}>بیشترین آرا</option>
                                <option value={``}>تازه ترین ها</option>
                                <option value={``}>پر بیننده ترین ها</option>

                            </select>
                            
                            <label className="lableFilter">انتخاب نوع چت : </label>
                            <select className="selectFilter"> 
                                <option value={``}>تالار گفتگوی همکاران</option>
                                <option value={``}>تالار گفتگوی دانشجویان</option>
                                <option value={``}>گفتوگوی عمومی    </option>

                            </select>
                            <label className="lableFilter mt-3">سوالات پاسخ داده شده :  </label>
                            <select className="selectFilter"> 
                                <option value={``}>همه</option>
                                <option value={``}>پاسخ داده شده</option>
                                <option value={``}>پاسخ داده نشده</option>

                            </select>
                            {/* <input type={`checkbox`} placeholder={``} className="mt-4 inputFilter"/> */}
                            <div style={{textAlign: "left", position: "relative", bottom: "0", height: "100%"}}>
                                <BCButom className="btnOne pt-2 pb-2 mt-4" style={{fontSize: "15px"}}>اعمال</BCButom>
                            </div>
                        </div>
                        <div className="mainChat">
                            <div className="titleSection"><h5>گفتگو</h5></div>     
                            <input type={`text`} name={``} className='inputSearchChat' placeholder="جست و جو در کفتگو..." />
                            <div className="w-100">
                                <div className="mainMassages" style={{visibility: "hidden"}}>
                                    <div className="messengerRequest">
                                        <img src="/image/149071.png" />
                                        <p><b>علی رضایی</b></p>
                                    </div>
                                    <div className="massageRquest" >
                                    \askdjhaskjdhkidas;klfjlk ikl fjlskdf 
                                        dfhsodkjlhf
                                        dfiolihd
                                        dafhdjs
                                        asdfhfsdgj
                                        sمنیشسابم 
                                        سیبحیب
                                        سیب
                                        یسب
                                        سیب
                                        سیب
                                        سیبیسبسیب
                                        سیبسیبسیب
                                        سیب
                                        یسب
                                        سی
                                        بسیبسیبسیبسی
                                        بسی
                                        بسی
                                        ب
                                        یس
                                        بسی
                                        ب
                                        یسب
                                    </div>
                                </div>
                                <div className="mainMassages" style={{visibility: "hidden"}}>
                                <div className="messengerAnswhare" >
                                <img src="/image/149071.png" />
                                        <p><b>مهدی  بقایی</b></p>
                                    </div>
                                    <div className="massageAnswhare">
                                        <div className="answareTo">
                                            <p>پاسخ به : <b>علی رضایی</b></p>
                                        </div>
                                        \askdjhaskjdhkidas;klfjlk ikl fjlskdf 
                                        dfhsodkjlhf
                                        dfiolihd
                                        dafhdjs
                                        asdfhfsdgj
                                        sمنیشسابم 
                                        سیبحیب
                                        سیب
                                        یسب
                                        سیب
                                        سیب
                                        سیبیسبسیب
                                        سیبسیبسیب
                                        سیب
                                        یسب
                                        سی
                                        بسیبسیبسیبسی
                                        بسی
                                        بسی
                                        ب
                                        یس
                                        بسی
                                        ب
                                        یسب
 
                                    </div>
                                </div>
                            </div>
                        </div>
                        

                    </Card>

                </Sidbar>
            </Master>
        </>
    )
}

export default Chat;